import Vue from 'vue'
import App from './App.vue'
import './assets/js/flexible'
import hls from 'videojs-contrib-hls'
import VideoPlayer from 'vue-video-player';
import "video.js/dist/video-js.css"
import "vue-video-player/src/custom-theme.css"
//导入图片预览viewer组件以及css
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,//解决图片放大的层级问题
  }
});
// setDeafaults配置
Viewer.setDefaults({
  Options: { "inline": true,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "url": "data-source" }
})

// import router from './router'
import router from './permission'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import '@/assets/css/media.css'
import '@/assets/font/iconfont.css'
//富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// // //实现quill-editor编辑器拖拽上传图片
import * as Quill from 'quill'
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
// //
// // //实现quill-editor编辑器调整图片尺寸
// // import { container, QuillWatch } from 'quill-image-extend-module'
// import ImageResize from 'quill-image-resize-module' // 引用，调整图片大小
// Quill.register('modules/imageResize', ImageResize)
Vue.use(VueQuillEditor)
//瀑布流布局
import water from "vue-waterfall2";
Vue.use(water);
import EventBus from '@/utils/bus'
Vue.use(EventBus)
Vue.prototype.$EventBus = EventBus
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(hls)
Vue.use(VideoPlayer)
new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
